import React, { ReactElement } from 'react';

import type { CompanyInterface } from 'interfaces/company.interface';
import CompanyViewInfoHeader from 'components/company-view/company-view-info/header/header';
import CompanyViewInfoDescription from 'components/company-view/company-view-info/description/description';
import CompanyViewInfoMetadataDesktop from 'components/company-view/company-view-info/metadata/metadata.desktop';

import './info.desktop.scss';

interface CompanyViewInfoProps {
    company: CompanyInterface;
}

const CompanyViewInfoDesktop: React.FC<CompanyViewInfoProps> = ({ company }): ReactElement => (
    <div className="company-view-info">
        <CompanyViewInfoHeader name={company.fullName || company.name} url={company.url} />
        <div className="company-view-info__columns">
            <CompanyViewInfoMetadataDesktop company={company} />
            <CompanyViewInfoDescription text={company.description} />
        </div>
    </div>
);

export default CompanyViewInfoDesktop;
